import { PerformanceAudienceChartMetric } from '@/services/endpoints/performanceAudience';
import { FC } from 'react';
import { PerformanceDashboardViewModel } from '../../types';
import { PerformanceAudienceComparisonTable } from '../PerformanceAudienceComparisonTable';
import { PerformanceAudienceKpiRow } from '../PerformanceAudienceKpiRow';
import { PerformanceAudienceScopeBanner } from '../PerformanceAudienceScopeBanner';
import { PerformanceAudienceStoreVisits } from '../PerformanceAudienceStoreVisits';
import { PerformanceAudienceTrendSection } from '../PerformanceAudienceTrendSection';

type PerformanceDashboardViewProps = PerformanceDashboardViewModel & {
  dateRange: string;
  activeMetric: PerformanceAudienceChartMetric;
  onMetricChange: (metric: PerformanceAudienceChartMetric) => void;
  onEditScope?: () => void;
  onExportCsv?: () => void;
};

export const PerformanceDashboardView: FC<PerformanceDashboardViewProps> = ({
  summary,
  kpis,
  trend,
  comparison,
  storeVisits,
  dateRange,
  activeMetric,
  onMetricChange,
  onEditScope,
  onExportCsv,
}) => {
  return (
    <div className='grid gap-5'>
      {summary ? <PerformanceAudienceScopeBanner summary={summary} dateRange={dateRange} onEditScope={onEditScope} /> : null}

      <PerformanceAudienceKpiRow kpis={kpis} />

      <div className='grid gap-5 lg:grid-cols-2 lg:items-stretch'>
        <PerformanceAudienceTrendSection trend={trend} activeMetric={activeMetric} onMetricChange={onMetricChange} />
        <PerformanceAudienceComparisonTable rows={comparison} onExportCsv={onExportCsv} />
      </div>

      {storeVisits ? <PerformanceAudienceStoreVisits storeVisits={storeVisits} /> : null}
    </div>
  );
};
